let infoPage = {
  hide: false,
  cssStyle: {
    primaryColor: '#16b09c', //to koniecznie
    'font-family': 'Celias',
  },
  people: [
    {
      title: 'MULTIBOOK',
      // name: 'Ćwiczenia interaktywne zostały przygotowane na podstawie publikacji Biologia 6. Zeszyt ćwiczeń autorstwa Karoliny Archackiej, Magdaleny Kosackiej i Ilony Żeber-Dzikowskiej.',
      hideLine: true,
      tcssStyle: { 'font-weight': 'bold' },
    },
    {
      title: 'Koordynator projektu',
      name: '<i>Małgorzata Różańska-Foks</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
    {
      title: 'Redakcja merytoryczna',
      name: '<i>Małgorzata Różańska-Foks</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
    {
      title: 'Opracowanie graficzne',
      name: '<i>Tomasz Kozłowski</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
    {
      title: 'Opracowanie multimedialne',
      name: '<i>Grzegorz Wrzecionowski, Artur Syrek, Mateusz Zamaryka, Paweł Sala</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
  ],
  texts: [
    {
      text: '<b>© Wydawnictwo JUKA-91, Warszawa 2024</b>',
    },
    {
      text: '<div style="text-align:justify;text-justify:inter-word">Wszystkie prawa autorskie i&nbsp;prawa producenta do&nbsp;nagranych utworów zastrzeżone. Kopiowanie, wynajmowanie, wypożyczanie, wykorzystywanie tego nośnika do&nbsp;wykonań publicznych i&nbsp;nadań RTV bez&nbsp;zezwolenia zabronione.</div>',
    },
    {
      text: '<div style="text-align:justify;text-justify:inter-word">Powyższe zastrzeżenie nie obejmuje utworów udostępnionych na&nbsp;licencji Creative Commons oraz&nbsp;korzystania z&nbsp;utworów w&nbsp;zakresie dozwolonego użytku, który określają przepisy prawa.</div>',
    },
    {
      text: '<div style="text-align:justify;text-justify:inter-word">Wydawca oświadcza, że dołożył wszelkich starań, aby dotrzeć do&nbsp;wszystkich właścicieli i&nbsp;dysponentów praw autorskich. Osoby, których nie udało nam się ustalić, prosimy o kontakt z&nbsp;wydawnictwem.</div>',
    },
    {
      text: 'Wydawnictwo JUKA-91 Sp. z&nbsp;o.o.<br>ul. Jutrzenki 118<br>02-230 Warszawa<br>tel. 41 366 55 55',
    },
    {
      text: '<br><strong><h4>Wykaz dysponentów praw autorskich w&nbsp;multibooku</h4></strong>',
    },

    {
      text: '<strong>Lista nagrań</strong>',
    },
    {
      text: `
      <table style="width:100%;text-align:justify">
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'CD1';padding-inline-start:1rem">&nbsp;</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'CD2';padding-inline-start:1rem">&nbsp;</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.1';padding-inline-start:1rem">Fun Time</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.1';padding-inline-start:1rem">Fun Time</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.2';margin-bottom:0;padding-inline-start:1rem">Hello Song</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.2';margin-bottom:0;padding-inline-start:1rem">How Many Flowers?</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.3';margin-bottom:0;padding-inline-start:1rem">Bye-bye Song</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.3';margin-bottom:0;padding-inline-start:1rem">Listening Unit 6</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.4';margin-bottom:0;padding-inline-start:1rem">Fun Time Rhyme</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.4';margin-bottom:0;padding-inline-start:1rem">Story 6. I Love Winter</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.5';margin-bottom:0;padding-inline-start:1rem">Table Time Rhyme</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.5';margin-bottom:0;padding-inline-start:1rem">Seasons</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.6';margin-bottom:0;padding-inline-start:1rem">Move Your Body</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.6';margin-bottom:0;padding-inline-start:1rem">Yummy Food</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.7';margin-bottom:0;padding-inline-start:1rem">Play with Me</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.7';margin-bottom:0;padding-inline-start:1rem">Listening Unit 7</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.8';margin-bottom:0;padding-inline-start:1rem">Listening Unit 1</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.8';margin-bottom:0;padding-inline-start:1rem">Story 7. My Favourite Food</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.9';margin-bottom:0;padding-inline-start:1rem">Story 1. Let’s Play</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.9';margin-bottom:0;padding-inline-start:1rem">I Like My Lunch</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.10';margin-bottom:0;padding-inline-start:1rem">Games Are Fun</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.10';margin-bottom:0;padding-inline-start:1rem">It Can</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.11';margin-bottom:0;padding-inline-start:1rem">Can I Have</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.11';margin-bottom:0;padding-inline-start:1rem">Listening Unit 8</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.12';margin-bottom:0;padding-inline-start:1rem">Listening Unit 2</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.12';margin-bottom:0;padding-inline-start:1rem">It’s a Tiger</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.13';margin-bottom:0;padding-inline-start:1rem">Story 2. Great Idea</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.13';margin-bottom:0;padding-inline-start:1rem">Wild Animals</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.14';margin-bottom:0;padding-inline-start:1rem">Numbers</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.14';margin-bottom:0;padding-inline-start:1rem">Can I Play</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.15';margin-bottom:0;padding-inline-start:1rem">Where Is It</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.15';margin-bottom:0;padding-inline-start:1rem">Listening Unit 9</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.16';margin-bottom:0;padding-inline-start:1rem">Listening Unit 3</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.16';margin-bottom:0;padding-inline-start:1rem">Story 9. In the Playground</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.17';margin-bottom:0;padding-inline-start:1rem">Story 3. Where’s the Ball</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.17';margin-bottom:0;padding-inline-start:1rem">Let’s Go to the Playground</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.18';margin-bottom:0;padding-inline-start:1rem">My House</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.18';margin-bottom:0;padding-inline-start:1rem">What Are You Wearing</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.19';margin-bottom:0;padding-inline-start:1rem">In a Fairy Tale Land</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.19';margin-bottom:0;padding-inline-start:1rem">Listening Unit 10</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.20';margin-bottom:0;padding-inline-start:1rem">Listening Unit 4</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.20';margin-bottom:0;padding-inline-start:1rem">Story 10. A Big Wave</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.21';margin-bottom:0;padding-inline-start:1rem">Story 4. Princess Poppy</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.21';margin-bottom:0;padding-inline-start:1rem">On the Beach</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.22';margin-bottom:0;padding-inline-start:1rem">In the Castle</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.22';margin-bottom:0;padding-inline-start:1rem">Christmas Counting</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.23';margin-bottom:0;padding-inline-start:1rem">The Rainy Day</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.23';margin-bottom:0;padding-inline-start:1rem">Where’s the Pot of Gold</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.24';margin-bottom:0;padding-inline-start:1rem">Listening Unit 5</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.24';margin-bottom:0;padding-inline-start:1rem">Easter Freeze</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.25';margin-bottom:0;padding-inline-start:1rem">Story 5. Stormy Weather</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.25';margin-bottom:0;padding-inline-start:1rem">Happy Family</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.26';margin-bottom:0;padding-inline-start:1rem">Weather</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.26';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 6</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.27';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 1</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.27';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 7</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.28';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 2</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.28';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 8</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.29';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 3</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.29';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 9</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.30';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 4</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2.30';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 10</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1.31';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary Unit 5</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'';margin-bottom:0;padding-inline-start:1rem"></li></ul></td>
      </tr>
`,
    },
    {
      text: '<b>Słowa:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Muzyka i aranżacja:</b> Stefan Gąsieniec',
    },
    {
      text: `<div style="text-align:justify;text-justify:inter-word"><b>Wykonawcy:</b> Andy Edwins – 1.9, 1.12, 1.13, 1.17, 1.21, 1.25, 1.26, 1.28, 1.30, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.11, 2.12, 2.13, 2.14, 2.15, 2.16, 2.17, 2.18, 2.19, 2.20,
2.26, 2.28, 2.30; Mateusz Jaworski – 1.2, 1.3, 1.4, 1.5, 1.8, 1.9, 1.10, 1.11, 1.12, 1.13, 1.14, 1.15, 1.16, 1.17, 1.19, 1.20, 1.21, 1.23, 1.24, 1.25, 2.3, 2.4, 2.7, 2.8, 2.9,
2.10, 2.11, 2.12, 2.15, 2.16, 2.18, 2.19, 2.20, 2.21, 2.22, 2.23, 2.24, 2.25; Juliette Edwins – 1.3, 1.7, 1.8, 1.9, 1.11, 1.13, 1.15, 1.16, 1.17, 1.19, 1.20, 1.21, 1.22, 1.24,
1.25, 1.27, 1.29, 1.30, 2.2, 2.3, 2.4, 2.5, 2.6, 2.8, 2.12, 2.14, 2.16, 2.20, 2.22, 2.23, 2.24, 2.25, 2.27, 2.29; Georgia Wojkiewicz – 1.9, 1.12, 1.13, 1.17, 1.18, 1.21, 1.22,
1.23, 1.25; Amy Routledge – 2.4, 2.7, 2.8, 2.11, 2.12, 2.15, 2.16, 2.18, 2.19, 2.20</div>`,
    },
    {
      text: '<b>Nagrania zrealizowano w:</b> Altberg Studio Stefan Gąsieniec',
    },
    {
      text: '<b>Reżyseria nagrań i&nbsp;mastering:</b> Stefan Gąsieniec<br /><br />',
    },
    {
      text: '<strong>Plakaty</strong>',
    },
    {
      text: '<b>Autorka:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Ilustracje:</b> Wojciech Stachyra: plakaty z&nbsp;historyjkami, 11,12,13,14, 15, Revise Units',
    },
    {
      text: `
      <div style="text-align:justify;text-justify:inter-word"><b>Shutterstock.com:</b> Plakat 1a: matimix (piłka nożna), Tatevosian Yana (gra w&nbsp;klasy), Rawpixel.com (gra karciana), icemanphotos (gra komputerowa), ur72
(gra planszowa), SergiyN, DoublePHOTO, studio, paffy, irin-k, New Africa (roześmiane dzieci); Plakat 2a: goh seok thuan (piórnik), Arra Vais (4 piórniki), ajt (2
gumki do&nbsp;ścierania), Ievgenii Meyer (3 długopisy), GotziLA STOCK (5 kredek świecowych), matkub2499 (6 klejów), jaroslava V (7 mazaków), Mongta Studio
(8 kredek), tnehala77 (9 gumek), Volodymyr Krasyuk (10 długopisów); Plakat 3a: David Calvert (dom); Plakat 4a: Thichaa (złoto), Marti Bug Catcher (zamek),
Yellow Cat (korona), n_defender (miecz), New Africa (różdżka); Plakat 5a: Vibrant Image Studio (słonecznie), Roxana Bashyrova (mgliście), Tracy Kerestesh
(burzowo), Kichigin (deszczowo), tumsuk (pochmurnie); Plakat 6a: Olis Design (kula ziemska); Plakat 7a: paulista (frytki), Drozhzhina Elena (kanapki), Eywa
(czekolada), Anna Kucherova (gruszka), shanshinyury (banan, śliwka, jabłko), AlexandrBognat (puszka napoju), ), Elena Schweitzer (orzechy), exopixel (pu-
dełko na&nbsp;śniadanie); Plakat 8a: musicman (pióro nad&nbsp;dłonią), Maridav (podnoszenie ćiężarków), sportpoint (lekkoatleta), YAKOBCHUK VIACHESLAV (senior),
dptro (ryczący tygrys), R.M. Nunes (tukan), Pyty (żyrafa), Ira Sokolovskaya (małpa), neelsky (tygrys), Anton_Ivanov (krokodyl), Fabian Plock (słoń); Plakat 9a:
Victor1153 (zjeżdżalnia), Popovphoto (huśtawka), Philipp1983 (piaskownica), Ahmet AYUNAL (huśtawka wagowa), Oleksii Synelnykov (plac zabaw); Plakat
10a: Marijs Jan (plaża), KlavdiyaV (morze), EpicStockMedia (fala), Africa Studio (ręcznik), MR. BUDDEE WIANGNGORN (piasek)<br /><br /></div>`,
    },
    {
      text: '<strong>Karty pracy</strong>',
    },
    {
      text: '<b>Autorka:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Ilustracje:</b> Wojciech Stachyra, Agnieszka Suszczyńska – kontur pod&nbsp;folię',
    },
    {
      text: `
      <div style="text-align:justify;text-justify:inter-word"><b>Shutterstock.com:</b> Shutterstock.com: s. 27: Vac1 (smok), Thichaa (złoto), Marti Bug Catcher (zamek), VeronArt16 (księżniczka), LightField Studios (król), s.
34: Vibrant Image Studio(słonecznie), Roxana Bashyrova (mgliście), Krivosheev Vitaly (burzowo), Kichigin (deszczowo), tumsuk (pochmurnie) s. 41: Oksistyle
(liście jesienią), arjma (owoce na&nbsp;drzewie), CHAINFOTO24 (kwiaty na&nbsp;drzewie), aaltair (drzewo zimą), s. 49: Kovaleva_Ka (orzechy), MaraZe (zupa pomido-
rowa), Phant (pieczona ryba), gresie (czekolada), M. Unal Ozmen (frytki) s. 55: Four Oaks (słoń), apple2499 (tygrys), g_tech (żyrafa), rawisoot (tukan), Billion
Photos (małpa), warat42 (krokodyl), s. 63: ndstudio1982 (zjeżdżalnia), Popovphoto (huśtawka), audiznam260921 (piaskownica), Andrii Spy_k (równoważ-
nia), photokup (trampolina), s. 69: Marijs Jan (plaża), KlavdiyaV (morze), MR. BUDDEE WIANGN-GORN (piasek), EpicStockMedia (fala), Andrienko Anastasiya
(ręcznik), Matthew Xan (okulary przeciwsłoneczne)<br /><br /></div>`,
    },
    {
      text: '<strong>Karty obrazkowe</strong>',
    },
    {
      text: '<b>Autorka:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Ilustracje:</b> Wojciech Stachyra',
    },
  ],
};
module.exports = infoPage;
